import React from "react";
import { X, Zap } from "lucide-react";
import { VLYT } from "@/constants/testIds/vlyt";
import { logInstallEvent } from "@/lib/api";
import WaitlistModal from "@/components/vlyt/WaitlistModal";

const KEY = "vlyt.install-banner.dismissed.v1";

export default function InstallBanner() {
  const [visible, setVisible] = React.useState(false);
  const [openWaitlist, setOpenWaitlist] = React.useState(false);

  React.useEffect(() => {
    const dismissed = localStorage.getItem(KEY);
    if (dismissed) return;
    const onScroll = () => {
      if (window.scrollY > window.innerHeight * 0.8) {
        setVisible(true);
        window.removeEventListener("scroll", onScroll);
        logInstallEvent("banner_view");
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
    logInstallEvent("banner_dismiss");
  };

  if (!visible) return <WaitlistModal open={openWaitlist} onOpenChange={setOpenWaitlist} source="install_banner" />;

  return (
    <>
      <div
        data-testid={VLYT.installBanner.root}
        className="fixed z-40 bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:left-auto md:bottom-6 md:max-w-md rounded-2xl border border-[color:var(--vlyt-border)] bg-[color:var(--vlyt-surface-1)] shadow-[0_20px_60px_rgba(0,0,0,0.5)] p-4 md:p-5 flex items-start gap-4 animate-in slide-in-from-bottom-4 fade-in"
      >
        <div className="h-10 w-10 rounded-xl bg-lime flex items-center justify-center shrink-0">
          <Zap size={18} className="text-[color:var(--vlyt-base)]" strokeWidth={2.8} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display text-[15px] leading-tight">Get Vlyt on your device</div>
          <div className="text-[13px] text-[color:var(--vlyt-muted)] mt-1">
            We're rolling out cohort-by-cohort. Reserve your spot in 20 seconds.
          </div>
          <div className="mt-3 flex items-center gap-2">
            <button
              type="button"
              onClick={() => {
                setOpenWaitlist(true);
              }}
              data-testid={VLYT.installBanner.accept}
              className="btn-lime !py-2 !px-4 !text-[13px]"
            >
              Join waitlist
            </button>
            <button
              type="button"
              onClick={dismiss}
              data-testid={VLYT.installBanner.dismiss}
              className="text-[13px] text-[color:var(--vlyt-muted)] hover:text-[color:var(--vlyt-text)] px-2 py-2"
            >
              Later
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss install banner"
          className="text-[color:var(--vlyt-muted)] hover:text-[color:var(--vlyt-text)]"
        >
          <X size={16} />
        </button>
      </div>
      <WaitlistModal open={openWaitlist} onOpenChange={setOpenWaitlist} source="install_banner" />
    </>
  );
}
